import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { App } from './app/App';
import './index.css';

const root = ReactDOMClient.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);